class SLIders extends HTMLElement {
    constructor() {
        super();
        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 20,
            breakpoints: {
                749: {
                    cssMode: false
                }
            },
            // If we need pagination
            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },

            // Navigation arrows
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },

            // And if we need scrollbar
            scrollbar: {
                el: this.querySelector('.swiper-scrollbar'),
            },

        });

        window.addEventListener('resize', this.updateHeightContent.bind(this))

    }

    updateHeightContent() {
        const maxHeight = [];
        this.querySelectorAll('.bab-guide__image-grid-item-text').forEach((item) => {
            maxHeight.push(item.offsetHeight);
        })

        this.querySelectorAll('.bab-guide__image-grid-item-text').forEach((item) => {
            item.style.height = `${Math.max(...maxHeight)}px`;
        })
    }
}

customElements.define('new-sliders', SLIders);